export default {
    SHOW_LOGIN_VIEW: 'SHOW_LOGIN_VIEW',
    CLOSE_LOGIN_VIEW: 'CLOSE_LOGIN_VIEW',
    CHANGE_STEP: 'CHANGE_STEP',
    CHANGE_REGISTER_PASSWORD: 'CHANGE_REGISTER_PASSWORD',
    CHANGE_EMAIL: 'CHANGE_EMAIL',
    CHANGE_CONFIRM_EMAIL: 'CHANGE_CONFIRM_EMAIL',
    CHANGE_COUNTRY_CODE: 'CHANGE_COUNTRY_CODE',

    CHANGE_LOGIN_PASSWORD_STATUS: 'CHANGE_LOGIN_PASSWORD_STATUS',

    SET_INTERVAL_TIME: 'SET_INTERVAL_TIME',
    SET_FORGET_PASSWORD_INTERVAL_TIME: 'SET_FORGET_PASSWORD_INTERVAL_TIME',
    FORGET_PASSWORD_TIME_SHOW: 'FORGET_PASSWORD_TIME_SHOW',
    CHANGE_REGISTER_CODE: 'CHANGE_REGISTER_CODE',

    VERIFICATION_TIME_SHOW: 'VERIFICATION_TIME_SHOW',
};
